import React, { useCallback, useState } from "react";
import { TextField } from "@mui/material";
import { debounce } from "services/debounce/debounce";
import { useTranslation } from "react-i18next";

interface InputProps {
  type?: string;
  id?: string;
  className?: string;
  label?: string;
  value?: any;
  onChange?: any;
  name?: string;
  placeholder?: string;
  setFilter?: any;
}

const CustomInput = ({
  type = "text",
  id,
  className,
  label,
  value,
  name = "search",
  placeholder = "Qidirish",
  setFilter,
}: InputProps) => {
  const [query] = useState(value);
  const { t } = useTranslation();

  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setFilter((prev: any) => ({ ...prev, [name]: value }));
  };

  const debouncedChangeHandler = useCallback(debounce(changeHandler, 300), []);

  return (
    <TextField
      type={type}
      id={id}
      name={name}
      label={label}
      placeholder={t(placeholder)}
      defaultValue={query}
      onChange={debouncedChangeHandler}
      autoComplete="off"
      size="small"
      fullWidth
      className={className}
    />
  );
};

export default CustomInput;
